export const Session = {
  set: (sessionName, value) => {
    localStorage.setItem(sessionName, JSON.stringify(value));
  },
  get: (sessionName) => {
    let storage = localStorage.getItem(sessionName);

    return storage ? JSON.parse(localStorage.getItem(sessionName)) : false;
  },
  remove: (sessionName) => {
    localStorage.removeItem(sessionName);
  }
};

export default function (app) {
  return app.config.globalProperties.$Session = Session;
}
